import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {ExUtilisateur} from '../../../class/ex/ex-utilisateur';
import {Subscription} from 'rxjs';
import {ExLaboratoire} from '../../../class/ex/ex-laboratoire';
import {MatDialog} from '@angular/material/dialog';
import {
    ModalChoixLaboratoireReferenceComponent
} from '../modal-choix-laboratoire-reference/modal-choix-laboratoire-reference.component';
import {LaboratoireReference} from '../../../class/api/LaboratoireReference';
import {Adresse} from '../../../class/api/Adresse';
import {ExCountry} from '../../../class/ex/ex-country';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {ToolsService} from '../../services/tools/tools.service';
import {Personne} from '../../../class/api/Personne';
import {PersonneResponsable} from '../../../class/api/PersonneResponsable';
import {ModalModifierLaboratoireComponent} from '../modal-modifier-laboratoire/modal-modifier-laboratoire.component';
import {LaboratoireReferenceSuggestion} from '../../../class/api/LaboratoireReferenceSuggestion';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Field} from '../../../class/api/Field';
import {LaboratoireValidationService} from '../../services/laboratoire-validation.service';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { ControlsMessagesComponent } from '../controls-messages/controls-messages.component';
import { GeocoderComponent } from '../geocoder/geocoder.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';

@Component({
    selector: 'app-lab-struct-and-perso-for-dossier',
    templateUrl: './lab-struct-and-perso-for-dossier.html',
    styleUrls: ['./lab-struct-and-perso-for-dossier.scss'],
    providers: [LaboratoireValidationService],
    imports: [MatButton, MatIcon, MatTooltip, FormsModule, ControlsMessagesComponent, GeocoderComponent, MatSelect, MatOption, MatCheckbox, MatAutocompleteTrigger, NgClass, MatAutocomplete, TranslateModule]
})
export class LabStructAndPersoForDossierComponent implements AfterViewInit{
    private hydraService = inject(HydraService);
    private matDialog = inject(MatDialog);
    private toolService = inject(ToolsService);
    private ngxTranslateService = inject(TranslateService);
    private laboValidationService = inject(LaboratoireValidationService);
    private changeDetector = inject(ChangeDetectorRef);

    public user: ExUtilisateur = null;
    public labo: ExLaboratoire = null;
    public uniteInsermSelected = false;
    public uniteCnrsSelected = false;
    public universiteFaculteSelected = false;


    @Input() public restrictCountryValue: string;
    public laboratoire: ExLaboratoire = null;
    @Output() public updateLaboratoire: EventEmitter<ExLaboratoire> = new EventEmitter();
    @Input() public disabled: boolean;
    public countries: ExCountry[] = [];
    //Select pour l'étape Mon Laboratoire
    public uniteInserm: any[] = [];
    public filteredUniteInserm: any[] = [];
    public uniteInsermSearch: any = '';
    public universiteFaculte: any[] = [];
    public filteredUniversiteFaculte: any[] = [];
    public universiteFaculteSearch: any = '';
    public uniteCnrs: any[] = [];
    public filterdUniteCnrs: any[] = [];
    public uniteCnrsSearch: any = '';

    public _timout;
    private subscriptions: Subscription[] = [];
    private _fieldKey = 'fieldArray';
    //trads
    private messageModifStruct = 'field.laboratoire.modifStructureLabel';
    private messageDemandeChangementLabo = 'field.laboratoire.valideDemandeChangement';
    private messageAnnuler = 'general.annuler';
    private messageDemandeEnvoye = 'field.laboratoire.demandeChangementEnvoye';
    private messageSaisieLibre = 'general.saisieLibre';

    constructor() {
        this.getTranslations();
    }

    public _field: Field = null;

    @Input() set field(value: Field) {
        if (value) {
            this._field = value;
        }
    }

    private _autonome = false;

    @Input() set autonome(value: boolean) {
        if (value != undefined && value === true) {
            this._fieldKey = 'fieldArrayAutonome';
        }
        this._autonome = value;
    }

    @Input() set passLaboratoire(value: ExLaboratoire) {
        this.getCountry();
        this.loadUnitesOnce();

        if (value == null) {
            return;
        }




        // première fois que l'on injecte le labo
        if (this.laboratoire == null) {
            const temp = new ExLaboratoire(value);
            if (temp.adresse == null) {
                temp.adresse = new Adresse();
            }
            this.laboratoire = temp;
            return;
        }

        // on force le changement d'ID, c'est le composant qui gère la sauvegarde qui commande
        this.laboratoire.id = value.id;
        this.laboratoire['@id'] = value['@id'];


        const directeurDivisionFromValue = value.directeurDivision;


        // standards de ce composant, en attendant des interfaces dédiées
        if (!(directeurDivisionFromValue instanceof PersonneResponsable)) {
            throw new Error('Le directeur de division passé en entrée devrait etre une instance de PersonneResponsable');
        }

        if (!this.laboratoire.directeurDivision || typeof this.laboratoire.directeurDivision == 'string') {
            this.laboratoire.directeurDivision = directeurDivisionFromValue;
        }

        this.laboratoire.directeurDivision.id = directeurDivisionFromValue.id;
        this.laboratoire.directeurDivision['@id'] = directeurDivisionFromValue['@id'];

        const directeurDivisionPersonneFromValue = directeurDivisionFromValue.personne;
        if (!(directeurDivisionPersonneFromValue instanceof Personne)) {
            throw new Error('Le détail du directeur de division passé en entrée devrait etre une instance de Personne');
        }

        if (!this.laboratoire.directeurDivision.personne || typeof this.laboratoire.directeurDivision.personne == 'string') {
            this.laboratoire.directeurDivision.personne = directeurDivisionPersonneFromValue;
        }

        this.laboratoire.directeurDivision.personne.id = directeurDivisionPersonneFromValue.id;
        this.laboratoire.directeurDivision.personne['@id'] = directeurDivisionPersonneFromValue['@id'] ;

        const adresseFromValue = value.adresse;
        if(adresseFromValue){
            if (typeof adresseFromValue == 'string') {
                throw new Error('Objet Adresse requis dans le laboratoire, string given');
            }

            if (!this.laboratoire.adresse || typeof this.laboratoire.adresse == 'string') {
                this.laboratoire.adresse = adresseFromValue;
            }

            this.laboratoire.adresse.id = adresseFromValue.id;
            this.laboratoire.adresse['@id'] = adresseFromValue['@id'];
        }

        this.laboratoire = new ExLaboratoire(this.laboratoire);

    }

    public getTranslations() {
        this.subscriptions.push(this.ngxTranslateService.get(this.messageModifStruct).subscribe(res => this.messageModifStruct = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageDemandeChangementLabo).subscribe(res => this.messageDemandeChangementLabo = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageAnnuler).subscribe(res => this.messageAnnuler = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageDemandeEnvoye).subscribe(res => this.messageDemandeEnvoye = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageSaisieLibre).subscribe(res => this.messageSaisieLibre = res));
    }

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public compareByCode(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.code == itemTwo.code;
    }

    public compareByLetter(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }


    public isValid() {
        return this.laboValidationService.isValid(this.laboratoire);
    }

    public getCountry() {
        if (!this.countries.length) {
            this.hydraService.getList(api.countries, true).subscribe(res => {
                this.countries = res.getMember();

                if (
                    this.laboratoire != null &&
                    typeof this.laboratoire != 'string'
                ) {
                    if (
                        this.laboratoire.laboratoireReference != null &&
                        this.laboratoire['laboratoireReference']['adresse'] !=
                        null &&
                        typeof this.laboratoire['laboratoireReference']['adresse'][
                            'pays'
                            ] == 'string'
                    ) {
                        this.countries.forEach(item => {
                            if (
                                item['@id'] ==
                                this.laboratoire['laboratoireReference']['adresse'][
                                    'pays'
                                    ]
                            ) {
                                this.laboratoire['laboratoireReference']['adresse'][
                                    'pays'
                                    ] = item;
                            }
                        });
                    }

                    if (
                        this.laboratoire != null &&
                        this.laboratoire['adresse'] != null &&
                        typeof this.laboratoire['adresse']['pays'] == 'string'
                    ) {
                        this.countries.forEach(item => {
                            if (
                                item['@id'] == this.laboratoire['adresse']['pays']
                            ) {
                                this.laboratoire['adresse']['pays'] = item;
                            }
                        });
                    }
                }
            });
        }
    }

    public deleteLaboRef() {
        const dialog = this.matDialog.open(ModalConfirmationComponent);
        dialog.afterClosed().subscribe(res => {
            if (res && res == true) {
                // @todo : supprimer labo de ref (si celui de l'utilisateur et etat !=1)
                this.laboratoire['laboratoireReference'] = null;
                this.laboratoire.adresse = new Adresse({'@id': this.laboratoire.adresse['@id'] });
                this.laboratoire.nom = '';

                // On ne delete pas l'id du responsable
                if(this.laboratoire.directeurDivision && this.laboratoire.directeurDivision['personne']){
                    this.laboratoire.directeurDivision['personne']['civilite'] = null;
                    this.laboratoire.directeurDivision['personne']['nom'] = null;
                    this.laboratoire.directeurDivision['personne']['prenom'] = null;
                }

                this.laboratoire.division = '';
                this.laboratoire = new ExLaboratoire(this.laboratoire);

                this.updateLaboratoire.emit(this.laboratoire);


            }
        });
    }

    public demandeDeModification() {

        if (
            this.laboratoire &&
            this.laboratoire['laboratoireReference'] &&
            this.laboratoire['laboratoireReference'] != null
        ) {
            const dialog = this.matDialog.open(ModalModifierLaboratoireComponent, {
                data: {
                    content: this.messageModifStruct,
                    confirm: this.messageDemandeChangementLabo,
                    cancel: this.messageAnnuler,
                },
            });
            dialog.afterClosed().subscribe(res => {
                if (res && res.length) {
                    const data = new LaboratoireReferenceSuggestion({
                        commentaire: res,
                        laboratoireReference: this.laboratoire[
                            'laboratoireReference'
                            ]['@id'],
                    });

                    this.hydraService
                        .post(api.laboratoireReferenceSuggestion, data)
                        .subscribe(() => {
                            this.toolService.notificationInfo(
                                this.messageDemandeEnvoye,
                                3000
                            );
                        });
                }
            });
        } else {
            // WARNING : au cas ou, je ne sais pas comment dans Sentry un mec à réussi a avoir cette popUp sans avoir de laboratoire
            // WARNING : ce qui ne devrait pas être possible ..
            alert('Pour demander une modification de votre structure vous devez en séléctionnez une');
        }


    }

    public searchStructure() {
        const dialog = this.matDialog.open(
            ModalChoixLaboratoireReferenceComponent,
            {
                height: 'auto',
                maxHeight: '82%',
                width: '1040px',
                maxWidth: '1040px',
                data: {
                    newReference: false,
                },
                panelClass: 'arc-dialog-panel',
                backdropClass: 'arc-dialog-backdrop',
            }
        );
        dialog
            .afterClosed()
            .subscribe((res: LaboratoireReference | boolean) => {
                if (res) {

                    this.laboratoire.laboratoireReference = res as LaboratoireReference;
                    // Si labo étrangé on reset le reste du laboratoire de base
                    if (this.laboValidationService.laboRefIsNotFr(res)) {
                        this.laboratoire = new ExLaboratoire({
                            id: this.laboratoire.id,
                            laboratoireReference: res
                        });
                    } else {
                        this.laboratoire.laboratoireReference = res as LaboratoireReference;

                        // Que si c'est un laboratoire en france en copy l'adresse
                        if (res['adresse'] != null) {
                            if (res['adresse'].numEtVoie && res['adresse'].numEtVoie == '-') {
                                res['adresse'].numEtVoie = '';
                            }
                            //Auto completion de l'adresse par contre on créer bien une nouvelle Instance en BDD
                            delete res['adresse']['@id'];
                            delete res['adresse']['id'];
                            this.laboratoire.adresse = new Adresse(res['adresse']);
                        }
                    }


                    this.updateLaboratoire.emit(this.laboratoire);
                }
                if (res == false) {
                    this.addNewLaboRef();
                }
            });
    }

    public laboRefEnFrance(): boolean {
        return (
            !this.laboValidationService.laboRefIsNotFr(this.laboratoire.laboratoireReference)
        );
    }

    public tutelleOk() {
        return (this.uniteCnrsSelected || this.uniteInsermSelected || this.universiteFaculteSelected || (this.laboratoire.autreEtablissementTutelleText != '' && this.laboratoire.autreEtablissementTutelleText != null));
    }

    loadUnitesOnce() {
        if (this.uniteInserm.length) {
            return;
        }

        this.hydraService
            .getList(api.inserm + '?enabled=true&itemsPerPage=500', true)
            .subscribe(res => {
                this.uniteInserm = new HydraCollection(res).getMember();
                this.filteredUniteInserm = [...this.uniteInserm];
                if (this.laboratoire) {
                    //CNRS
                    if (
                        this.laboratoire['uniteInsermOther'] != null ||
                        this.laboratoire['uniteInserm'] != null
                    )
                        {this.uniteInsermSelected = true;}
                    if (
                        this.laboratoire['uniteInsermOther'] != null &&
                        this.laboratoire['uniteInsermOther'].length
                    ) {
                        this.uniteInserm.map(item => {
                            if (
                                item['code'] != undefined &&
                                item['code'] == 'ZZZ_OTHER'
                            ) {
                                this.uniteInsermSearch = item;
                            }
                        });
                    } else {
                        this.uniteInsermSearch = this.laboratoire[
                            'uniteInserm'
                            ];
                    }
                }
            });

        this.hydraService
            .getList(api.cnrs + '?enabled=true&itemsPerPage=500', true)
            .subscribe(res => {
                this.uniteCnrs = new HydraCollection(res).getMember();
                this.filterdUniteCnrs = [...this.uniteCnrs];

                if (this.laboratoire) {
                    //CNRS
                    if (
                        this.laboratoire['uniteCnrsOther'] != null ||
                        this.laboratoire['uniteCnrs'] != null
                    )
                        {this.uniteCnrsSelected = true;}
                    if (
                        this.laboratoire['uniteCnrsOther'] != null &&
                        this.laboratoire['uniteCnrsOther'].length
                    ) {
                        this.uniteCnrs.map(item => {
                            if (
                                item['code'] != undefined &&
                                item['code'] == 'ZZZ_OTHER'
                            ) {
                                this.uniteCnrsSearch = item;
                            }
                        });
                    } else {
                        this.uniteCnrsSearch = this.laboratoire['uniteCnrs'];
                    }
                }
            });

        this.hydraService
            .getList(api.universiteFaculte + '?enabled=true&itemsPerPage=500', true)
            .subscribe(
                res => {
                    this.universiteFaculte = new HydraCollection(res).getMember();
                    this.filteredUniversiteFaculte = [...this.universiteFaculte];

                    if (this.laboratoire) {
                        //CNRS
                        if (
                            this.laboratoire['universiteFaculteOther'] != null ||
                            this.laboratoire['universiteFaculte'] != null
                        )
                            {this.universiteFaculteSelected = true;}
                        if (
                            this.laboratoire['universiteFaculteOther'] != null &&
                            this.laboratoire['universiteFaculteOther'].length
                        ) {
                            this.universiteFaculte.map(item => {
                                if (
                                    item['titre'] != undefined &&
                                    item['titre'] == 'ZZZ_OTHER'
                                ) {
                                    this.universiteFaculteSearch = item;
                                }
                            });
                        } else {
                            this.universiteFaculteSearch = this.laboratoire[
                                'universiteFaculte'
                                ];
                        }
                    }
                }
            );
    }

    public displayAutoCompleteLabel() {
        return (item) => this.prepareLabelForDisplayAutoCompleteLabel(item);
    }

    private prepareLabelForDisplayAutoCompleteLabel(item) {
        if (item && item['titre'] != undefined) {
            if (item['titre'] == 'ZZZ_OTHER') {
                return this.messageSaisieLibre;
            } else {
                return item['titre'];
            }
        } else {
            return '';
        }
    }

    public displayAutoComplete() {
        return (item) => this.prepareLabelForDisplayAutoComplete(item);
    }

    private prepareLabelForDisplayAutoComplete(item: any) {
        if (item && item['code'] != undefined) {
            if (item['code'] == 'ZZZ_OTHER') {
                return this.messageSaisieLibre;
            } else {
                let title = '';
                if (item['titre'] != undefined && item['titre'].length) {
                    title = item['titre'];
                    if (title.length > 30) {
                        title = title.substring(0, 30) + '...';
                    }
                }
                return item['code'] + ' - ' + title;
            }
        } else {
            return '';
        }
    }

    public resetResearch(ngModel: string, dataSource: string, dateSourceFiltered: string) {
        setTimeout(_ => {
            if (typeof this[ngModel] == 'string') {
                this[ngModel] = '';
                this[dateSourceFiltered] = [...this[dataSource]];
            }
        }, 200);
    }

    public filterSelect(str = '', dataSource: string, dateSourceFiltered: string) {
        this[
            dateSourceFiltered
            ] = this.toolService.filterForNgModelAutoComplete(
            str,
            'code',
            this[dataSource]
        );
    }

    public filterSelectLabel(str = '', dataSource: string, dateSourceFiltered: string) {
        this[
            dateSourceFiltered
            ] = this.toolService.filterForNgModelAutoComplete(
            str,
            'titre',
            this[dataSource]
        );
    }

    public updateSelect(str: []|string = '', itemOther: string, otherKey: string) {
        if (typeof str === 'object') {
            if (str[otherKey] != undefined) {
                if (str[otherKey] != 'ZZZ_OTHER') {
                    this.laboratoire[itemOther] = str[otherKey];
                }
            }
        } else {
            this.laboratoire[itemOther] = null;
        }

        this.updateLaboratoire.emit(this.laboratoire);
    }

    public addNewLaboRef() {
        const structure = new LaboratoireReference();
        structure['isMine'] = true;
        structure.adresse = new Adresse();
        structure.directeur = new Personne();

        this.laboratoire.laboratoireReference = structure;
        this.laboratoire.adresse = new Adresse();
        this.laboratoire.directeurDivision = new PersonneResponsable(
            {
                personne: new Personne()
            }
        );
        this.laboratoire.nom = '';
        this.laboratoire.division = '';
        this.updateLaboratoire.emit(this.laboratoire);

    }

    public updateLaboRef() {
        if (this._timout) {window.clearTimeout(this._timout);}
        this._timout = window.setTimeout(() => {
            if (this.laboValidationService.laboReferenceIsSauvegardable(this.laboratoire.laboratoireReference)) {
                this.updateLaboratoire.emit(this.laboratoire);
            }
        }, 100);
    }


    /**
     * La structure est modifiable si à moi + non validé ou hors france
     *
     * @returns
     */
    public laboratoireReferenceModifiable(): boolean {
        if (this.laboratoire == null || this.laboratoire['laboratoireReference'] == null) {
            return false;
        }

        return (
            this.laboratoire['laboratoireReference']['isMine']
            && +this.laboratoire['laboratoireReference']['etat'] !== 1
        );
    }


    updateSelectBox(checked, itemOther: string) {
        if (!checked) {
            this.laboratoire[itemOther] = null;
            this.updateLaboratoire.emit(this.laboratoire);
        }
    }

    ngAfterViewInit(): void {
        this.changeDetector.detectChanges();
    }
}
